/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface RetentionPreviewOut {
  media_due_now: number;
  transcripts_due_now: number;
  media_due_30d: number;
  transcripts_due_30d: number;
  preview_token: string;
}
